export default __webpack_public_path__ + "static/media/cain11.35e4134f.jpg";